<template>
  <div
    class="mail-list-wrap"
    :class="{
      'mail-list--not-empty': value.length,
      'mail-list--invalid': isInvalid,
    }"
  >
    <button
      class="mail_btn-add"
      type="button"
      @click="() => addNewMail()"
    />
    <span class="mail-list_placeholder">{{ placeholder }}</span>
    <ul class="mail-list">
      <li
        v-for="(mail, index) in value"
        :key="`${index}`"
      >
        <share-modal-email-item
          class="mail"
          ref="mailItem"
          :mail-info="{ mail, index }"
          @update-mail="updateMail"
          @remove-mail="removeMail"
          @add-mail="addNewMail"
        />
      </li>
    </ul>
  </div>
</template>

<script>
  import ShareModalEmailItem from './ShareModalEmailItem';
  export default {
    name: 'ShareModalEmailList',
    components: { ShareModalEmailItem },
    props: {
      value: {
        type: Array,
        default: function() { return [] }
      },
      placeholder: {
        type: String, default: '',
      },
      isInvalid: {
        type: Boolean, default: false,
      }
    },
    watch: {
      'value.length'() {
        this.focusEmptyMail();
      }
    },
    methods: {
      updateMail({ mail, index }) {
        const list = [...this.value];
        list[index] = mail;
        this.updateList(list);
      },
      removeMail(index) {
        const list = [...this.value];
        list.splice(index, 1);
        this.updateList(list);
      },
      addNewMail({ index, newList = [''] } = {}) {
        let list = [...this.value];
        // add new mail only if hasn't empty mail
        if (list.includes('') && newList[0] === '') {
          this.focusEmptyMail();
          return;
        }
        if (typeof index === 'number') list.splice(index + 1, 0, ...newList)
        else list = [...list, ...newList];
        this.updateList(list);
      },
      updateList(list) {
        this.$emit('input', list);
      },
      focusEmptyMail() {
        const emptyIndex = this.value.findIndex((m) => m === '');
        if(emptyIndex < 0) return;
        this.$nextTick(() => {
          this.$refs.mailItem[emptyIndex].focus();
        })
      }
    },
  };
</script>

<style lang="scss" scoped>
  $list-gap: 4px;
  $input-color: rgba(#000, .5);
  .mail-list-wrap {
    position: relative;
    width: 100%;
    min-height: 3.5em;
    font-size: 16px;
    border-radius: 10px;
    padding: 11px;
    border: 1px solid $input-color;
    margin-bottom: 3px;
  }
  .mail-list--invalid {
    color: $color-red;
    border-color: $color-red;
  }
  .mail-list {
    display: inline-flex;
    vertical-align: middle;
    flex-wrap: wrap;
    list-style: none;
    margin: -$list-gap;
    padding: 0;
    max-width: 100%;
    li {
      margin: $list-gap;
      display: flex;
      max-width: 100%;
      overflow: hidden;
    }
  }
  .mail-list_placeholder {
    position: absolute;
    background-color: #fff;
    color: $input-color;
    padding: 0 5px;
    pointer-events: none;
    font-size: 18px;
    transition: transform .3s;
    transform-origin: left;
    .mail-list--not-empty & {
      transform: translate(0, -100%) scale(0.75);
    }
  }
  .mail {
    position: relative;
    z-index: 1;
  }
  .mail_btn-add {
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 10px;
    background: transparent;
    border: none;
  }
</style>
